import React, { useState, ChangeEvent, useEffect } from 'react';

interface DateInputProps {
    placeholder?: string;
    value?: string | null;
    min?: string;
    max?: string;
    disabled?: boolean;
    onValueChange: (value: string) => void;
    required?: boolean;
    isCurrentSelected?: boolean;
}

const DateInput: React.FC<DateInputProps> = ({ placeholder, value, min, max, disabled, onValueChange, required, isCurrentSelected }) => {
    const today = new Date().toISOString().split("T")[0];
    const [dateValue, setDateValue] = useState(value?.split("T")[0] ?? "");

    useEffect(() => {
        setDateValue(value?.split("T")[0] || "");
    }, [value]);

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setDateValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    return (
        <div className="date-input-container">
            <input
                type="date"
                value={isCurrentSelected ? today : dateValue}
                onChange={handleInputChange}
                className="form-control input-date"
                placeholder={placeholder}
                min={min}
                max={max}
                disabled={disabled}
            />
            {required && (
                <div className="required-asterisk-container">
                    <span className="text-danger p-absolute">*</span>
                </div>
            )}
        </div>
    );
};

export default DateInput;
